import { DexNamesEnum } from '@shared/enums/dex-names.enum';
import { NetworkNamesEnum } from '@shared/enums/networks.enum';
import { WalletTag } from '@shared/interfaces/eth-accounts.interface';
import { SolanaTokenTypeEnum, TokenInterface } from '@shared/interfaces/token.interface';

export enum MigrationSnipeStatusEnum {
    archived = 'archived',
    active = 'active',
    finished = 'finished',
    paused = 'paused',
}

export enum MigrationSnipeLogsStatusEnum {
    Success = 'Success',
    Pending = 'Pending',
    Failed = 'Failed',
}

export enum MigrationSnipeWizardStepEnum {
    created = 100,
    validation = 200,
    completed = 300,
}

export interface MigrationSniperInterface {
    id: number;
    dex: DexNamesEnum;
    status: MigrationSnipeStatusEnum;
    snipeWizardStep: MigrationSnipeWizardStepEnum;
    snipeName: string;
    walletsProfileId: number;
    walletsProfileName: string;
    walletsProjectId: number;
    walletsProjectName: string;
    walletsTenantId: number;
    walletsTenantName: string;
    baseToken: TokenInterface;
    quoteToken: TokenInterface;
    nativeToken: TokenInterface;
    creator: string;
    createdAt: string;
    data: MigrationSniperDataResponse;
}

interface MigrationSniperDataBasic {
    isBaseTokenDeployed: boolean;
    dexName: DexNamesEnum;
    networkName: NetworkNamesEnum;
    mcThreshold: number;
    slippage: number;
    wallets: SniperWallet[];
}

interface MigrationSniperDataResponse extends MigrationSniperDataBasic {
    baseToken: TokenExtendedInterface;
    quoteToken: TokenExtendedInterface;
    swapsCalculation: MigrationSnipeSwapsCalculation[];
}

interface MigrationSniperDataPayload extends MigrationSniperDataBasic {
    baseTokenData: TokenExtendedInterface;
    quoteAddress: string;
}

export interface SniperWallet {
    id: number;
    address: string;
    buyAmount: number;
    tags?: WalletTag[];
}

export interface MigrationSnipeSwapsCalculation {
    walletId: number;
    address: string;
    amountInQuote: number;
    amountOutBase: number;
    amountOutBaseBig: string;
    amountInQuoteBig: string;
    totalSupplyHeld: number;
    marketCap: number;
    priceChange: number;
}

export interface CreateMigrationSniperPayload {
    walletsProfileId: number;
    snipeName: string;
    data: MigrationSniperDataPayload;
}

export interface UpdateMigrationSniperPayload extends CreateMigrationSniperPayload {
    id: number;
}

export interface MigrationSnipeBalance {
    quoteBalance: string;
    baseBalance: string;
    nativeBalance: string;
}

export interface SwapWalletValidation {
    walletId: number;
    address: string;
    expectedQuoteBalance?: string;
    actualQuoteBalance?: string;
    quoteBalanceValidation?: boolean;
    expectedNativeBalance: string;
    actualNativeBalance: string;
    nativeBalanceValidation: boolean;
    quoteApproval: boolean;
    allValidations: boolean;
    tokenAccountValidation?: boolean;
}

export interface MigrationSnipeValidation {
    swapsValidations: SwapWalletValidation[];
    allValidations: boolean;
}

interface TokenExtendedInterface extends TokenInterface {
    type: SolanaTokenTypeEnum;
    name: string;
    totalSupply: number;
}

export interface CreateTokensAccountsResponse {
    walletId: number;
    walletAddress: string;
    baseTokenAccount: string;
    baseTokenAccountInitialized: boolean;
    quoteTokenAccount: string;
    quoteTokenAccountInitialized: boolean;
}
